<script setup lang="ts">
import { computed } from '#imports'

export interface UIErrorMessages {
    messages?: string[]
    dataTest?: string
}
const props = withDefaults(defineProps<UIErrorMessages>(), {
    messages: () => [],
    dataTest: ''
})

const message = computed(() => {
    if (!props.messages || props.messages.length === 0) return null

    // Only show the first error
    return props.messages[0]
})
</script>

<template>
    <div class="error-container">
        <Transition name="slide-up-inline">
            <!-- eslint-disable vue/no-v-html message is safe -->
            <div
                v-if="message"
                :data-test="`${props.dataTest}-error`"
                class="error-container__message"
                v-html="message"
            />
            <!-- eslint-enable vue/no-v-html -->
        </Transition>
    </div>
</template>

<style lang="scss" scoped>
.error-container {
    max-height: 100px;

    &__message {
        color: var(--danger, $red);
        font-size: $font-size-xs;
        padding-top: 4px;
    }
}
</style>
